var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_313_5712)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2H16V18H14V14C14 13.4477 13.5523 13 13 13H7C6.44772 13 6 13.4477 6 14V18H4V2ZM8 18H9V15H8V18ZM11 18H12V15H11V18ZM7 20H4C2.89543 20 2 19.1046 2 18V2C2 0.895431 2.89543 0 4 0H16C17.1046 0 18 0.895431 18 2V18C18 19.1046 17.1046 20 16 20H13H7ZM6 5C6 4.44772 6.44772 4 7 4H8C8.55228 4 9 4.44772 9 5V6C9 6.55228 8.55228 7 8 7H7C6.44772 7 6 6.55228 6 6V5ZM7 8C6.44772 8 6 8.44771 6 9V10C6 10.5523 6.44772 11 7 11H8C8.55228 11 9 10.5523 9 10V9C9 8.44772 8.55228 8 8 8H7ZM11 5C11 4.44772 11.4477 4 12 4H13C13.5523 4 14 4.44772 14 5V6C14 6.55228 13.5523 7 13 7H12C11.4477 7 11 6.55228 11 6V5ZM12 8C11.4477 8 11 8.44771 11 9V10C11 10.5523 11.4477 11 12 11H13C13.5523 11 14 10.5523 14 10V9C14 8.44772 13.5523 8 13 8H12Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_313_5712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor",
    transform: "translate(0 0.000488281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.85f0d0577baa98bfb91fca950ab0f17e.svg";
export { ForwardRef as ReactComponent };